<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    class?: string;
    children: Snippet;
  }

  let { class: klass = '', children }: Props = $props();
</script>

<div class="vd-control-grid {klass}">{@render children()}</div>

<style lang="scss">
  @use '../../styles/tokens' as *;

  .vd-control-grid {
    display: grid;
    gap: 1rem;
    align-items: start;
  }

  @media (min-width: $practice-split) {
    .vd-control-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: 2rem;
    }

    // An unpaired last control keeps the full row rather than half of it.
    .vd-control-grid > :global(:last-child:nth-child(odd)) {
      grid-column: 1 / -1;
    }
  }
</style>
